<template>
  <div class="view-userdetails">
    <div class="header mb-6">
      <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-arrow-left" class="p-0"
        @click="goBack()"></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ $t("labels.user_detail") }}</h2>
      </div>
      <div class="history w-1/2 justify-right">
        <vs-button color="dark" type="filled" icon-pack="feather" icon="icon-activity" @click="
          $router.push({ name: 'History', params: { id: id, model: model } })
          " class="float-right">{{ $t("labels.history") }}</vs-button>
      </div>
    </div>
    <vx-card class="user-card" :title="$t('labels.user')" v-if="user">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t("labels.name") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.name }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-1/2 sm:mt-4 md:mt-0" v-if="user.organisation_name">
              <div class="vx-row">
                <div class="vx-col sm:w-1/2">
                  <label>{{ $t("labels.organisation_name") }}:</label>
                </div>
                <div class="vx-col sm:w-1/2">
                  <span>{{ user.organisation_name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full mt-4">
            <div class="vx-col sm: w-full md:w-1/2">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t("labels.email") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.email }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t("labels.type") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.type | getUserType }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full mt-4">
            <div class="vx-col sm: w-full md:w-1/2" v-if="user.type === 'CL'">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t("labels.subtype") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.sub_type | getUserSubType }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2" v-if="user.type === 'A'">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t("labels.user_role") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2">
                  <span>{{ user.role.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card v-if="user && user.type === 'CL' && user.sub_type !== 'OW'" class="mt-10" :title="user.sub_type == 'M'
      ? $t('labels.owner')
      : user.sub_type == 'OF'
        ? $t('labels.manager')
        : $t('labels.office')
      ">
      <div class="vx-col sm: w-full md:w-1/2">
        <div class="vx-row">
          <div class="vx-col sm: w-1/2">
            <label>{{ $t("labels.name") }}:</label>
          </div>
          <div class="vx-col sm: w-1/2" v-if="user.parent">
            <span>{{ user.parent.name }}</span>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col sm: w-1/2">
            <label>{{ $t("labels.email") }}:</label>
          </div>
          <div class="vx-col sm: w-1/2" v-if="user.parent">
            <span>{{ user.parent.email }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div lass="view-btn">
            <vs-button radius color="primary" type="filled" icon-pack="feather" icon="icon-eye" class="float-right"
              title="View" @click.prevent="viewUser(user.parent.id)"></vs-button>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card v-if="user && user.type === 'CL' && user.sub_type !== 'F'" class="mt-10" :title="user.sub_type == 'OW'
      ? $t('labels.managers')
      : user.sub_type == 'M'
        ? $t('labels.offices')
        : $t('labels.fleets')
      ">
      <vs-table :data="user.children" class="mt-4 children-table">
        <template slot="thead">
          <vs-th>{{ $t("labels.name") }}</vs-th>
          <vs-th>{{ $t("labels.email") }}</vs-th>
          <vs-th>{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.name">{{ tr.name }}</vs-td>
            <vs-td :data="tr.email">{{ tr.email }}</vs-td>
            <vs-td :data="tr.organisation_name">
              <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-eye" title="View" size="large"
                @click.prevent="viewUser(tr.id)"></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <consultant-detail-view v-if="user && user.type === 'CN'" class="mt-6" :user-id="user.id"></consultant-detail-view>
    <consultant-documents v-if="user && user.type === 'CN'" class="mt-6" :user-id="user.id"></consultant-documents>
    <vx-card class="mt-6" :title="$t('labels.last_login')">
      <div class="vx-row">
        <div class="vx-col sm: w-full md:full mt-6">
          <vs-table :data="last_3_logins" class="permission">
            <template slot="thead">
              <vs-th>{{ $t("labels.ip_address") }}</vs-th>
              <vs-th>{{ $t("labels.login_at") }}</vs-th>
              <vs-th>{{ $t("labels.logout_at") }}</vs-th>
              <vs-th width="45%">{{ $t("labels.user_agent") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.ip_address }}</vs-td>
                <vs-td>{{ tr.login_at | date_format }}</vs-td>
                <vs-td>{{ tr.logout_at | date_format }}</vs-td>
                <vs-td>{{ tr.user_agent }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>
    <project v-if="user && user.type === 'CL'" class="mt-4" :user-id="user.id" :client_id="id"></project>
  </div>
</template>
<script>
import Project from "@/views/projects/listing";
import ConsultantDetailView from "@/views/users/consultant-details-view";
import ConsultantDocuments from "@/views/users/consultant-documents";

export default {
  components: {
    Project,
    ConsultantDetailView,
    ConsultantDocuments,
  },
  data() {
    return {
      user: null,
      model: "user",
      id: this.$route.params.id,
      last_3_logins: [],
    };
  },
  computed: {
    /* user: {
      get() {
        return this.$store.state.userData.user;
      },
      set(value) {
        this.$store.commit("updateUser", value, { module: "userData" });
      }
    } */
  },
  watch: {
    $route: function () {
      this.getUser();
    },
  },
  mounted() {
    //     if(!this.$store.state.userData.admins.length) {
    this.getUser();
    // }  else {
    //     let user = this.$store.state.userData.admins.find(admin => admin.id === this.$route.params.id);
    //     this.$store.commit('updateUser',user,{module:'userData'})
    // }
  },
  methods: {
    async getUser() {
      let response = await this.getHTTPGetResponse(
        "/users/get/" + this.$route.params.id
      );
      if (response) {
        let user = response.data.user;
        this.user = user;
        this.last_3_logins = user.last_3_logins;
      }
    },
    goBack() {
      history.back();
    },
    viewUser(id) {
      this.$router.push("/users/view/" + id);
    },
  },
};
</script>
<style scoped>
.view-userdetails label {
  font-weight: 600;
  margin-right: 10px;
}

h3 {
  text-decoration: underline;
  font-size: 18px;
  color: rgba(var(--vs-primary), 1);
  font-weight: 600;
}

.header h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
</style>
